/**
 * Decorative accent palette shared by the list/card surfaces.
 *
 * A wall of cards/rows reads as varied (rather than one flat hue) by giving
 * each entity a stable accent. `accentForIndex` colours by position (grids
 * where order is stable); `accentForKey` hashes an id/name so the same entity
 * keeps its colour across renders and pages.
 */

/** Bright -500 palette steps + the experiment accent and a neutral gray tile. */
export const ACCENT_PALETTE = [
  "var(--info-500)",
  "var(--success-500)",
  "var(--warning-500)",
  "var(--color-accent)",
  "var(--gray-800)",
  "var(--brand-500)",
] as const;

export function accentForIndex(index: number): string {
  return ACCENT_PALETTE[index % ACCENT_PALETTE.length]!;
}

export function accentForKey(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return ACCENT_PALETTE[hash % ACCENT_PALETTE.length]!;
}
